import { fetchV1 } from 'helpers/fetch.js';
import { toQueryString } from 'helpers/api.js';

export default {
  getEntityInsights(entityId, filters, type) {
    return fetchV1.get(`/${type}s/${entityId}/insights?${toQueryString(filters)}`);
  },
  getPartnershipInsights(brandId, publisherId, filters) {
    return fetchV1.get(`/brands/${brandId}/publishers/${publisherId}/insights?${toQueryString(filters)}`);
  },
  getHubsInsights(brandId, hubId, filters) {
    return fetchV1.get(`/brands/${brandId}/hubs/${hubId}/insights?${toQueryString(filters)}`);
  },
};
